export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAABXnVYT7FIskoUKMqoxfXpRKWglOXg3g',
    authDomain: 'pickcelsignage-ae51f.firebaseapp.com',
    databaseURL: 'https://pickcelsignage-ae51f.firebaseio.com',
    projectId: 'pickcelsignage-ae51f',
    storageBucket: 'pickcelsignage-ae51f.appspot.com',
    messagingSenderId: '525667527009',
    appId: '1:525667527009:web:f90b782307d2770a'
  }
};

export const missingAppLink: boolean = false;

/**
 * Customization in pickcel user code
 */
export const config = {
  SERVER_NAME: "ukapi",
  SERVER_URL: "https://ukapi.pickcel.com",
  FAVICON_PATH: "assets/org/remotescreencontrol/favicon.ico",
  APP_BASE_REF: "/",
  LOGIN: {
    LOGIN_COMPONENT: "PICKCEL",
    TITLE: "",
    DESCRIPTION: "A powerful yet easy to use application for managing your digital signage displays",
    FOOTER_TEXT: "",
    REGISTRATION_ALLOWED: false,
    GOOGLE_LOGIN: false,
    APPLE_LOGIN: false,
    TERMS_AND_CONDITION: false,
    FORGOT_PASSWORD_BUTTON: false,
    FACEBOOK_LOGIN: false,
    FACEBOOK_LINK: "#",
    TWITTER_LOGIN: false,
    TWITTER_LINK: "#",
    LINKEDIN_LOGIN: false,
    LINKEDIN_LINK: "#",
    TERMS_AND_CONDITION_LINK: "",
    LOGO_SRC: "assets/org/remotescreencontrol/logo.png",
    APP_ICON: "assets/org/remotescreencontrol/favicon.png",
    HOME_LOGO_SRC: "assets/org/remotescreencontrol/logo.png",
    SLIDER_IMG1: "assets/org/remotescreencontrol/slider1.svg",
    SLIDER_IMG2: "assets/org/remotescreencontrol/slider2.svg",
    SLIDER_IMG3: "assets/org/remotescreencontrol/slider2.svg",
    SIGNIN_TITLE: "Log In"
  },
  ROUTES: {
    LOGIN_COMPONENT: "PICKCEL"
  },
  SCREEN: {
    EMPTY_LIST_DESC: "Connect your display to Signage device and install Digital Signage player to add display",
    BUY_DEVICE_LINK: "",
    INSTALL_PLAYER_LINK: "",
    SHOW_PLAYERS: false,
    ADD_SCREEN_IMG: "assets/org/partner/add-display.png",
  },
  ZOHO: {
    CHECK_ZOHO_SUBSCRIPTION: false,
    SHOW_ZOHO_BUTTON: false,
    SHOW_ZOHO_TICKET: false,
    HEAT_MAP: false
  },
  ASSETS: {
    PDF_UPLOAD: true,
    PDF_TAB_SHOW: true
  },
  SESSION_AUTO_EXPIRED: false,
  SESSION_TIMEOUT: 12, //minutes
  REPORT: {
    "reportType": 'DEFAULT', //DEFAULT, CUSTOM, CUSTOM1
    "reportLogo": false,
    "AUDITLOG": true,
    "reportLogoPath": 'data:image/png;base64,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'
  },
  EDITOR: {
    SHOW: false,
    TOTAL_ZONES: 10,
    TOP_EDIT: false,
    LEFT_EDIT: false,
    WIDTH_EDIT: true,
    HEIGHT_EDIT: true,
    CUSTOM: true,
    SHOW_BG: false
  },
  APPS: {
    TOKEN_MANAGEMENT: false
  },
  ALLOWED_DOMAINS: [
    "login.remotescreencontrol.com",
    "ukapi.pickcel.com",
    "remotescreencontrol.s3-website.eu-west-2.amazonaws.com"
  ],
  CANVA_APP_KEY: "zN2KADl7Y74EOr3C6rQF0VI6",
  PEXELS_KEY: "563492ad6f917000010000019304566d8b2d4c92978af9a8a8894540",
  AWS: {
    HOSTNAME: "",
    CLOUDFRONT_NAME: "https://d2qf6k8jfqd09k.cloudfront.net",
    SERVER_NAME: "signage"
  },
  HOST_URL: 'https://login.remotescreencontrol.com',

  MENU_APP: {
    IMG_LOGO: "https://d2qf6k8jfqd09k.cloudfront.net/v3-apps/menu-app.svg",
    HOST_NAME: 'menu',
    PRIMARY_COLLECTION: 'apps',
    DOCUMENT: 'signage',
    SECONDARY_COLLECTION: 'menu-app',
    FIREBASE_HEADERS: {
      TOKEN: 'Bearer 27ade1dd70d27e07cdf28ed3107145f5',
      SERVER: 'prod'
    },
    BASE_URL: 'https://widget.pickcel.com/v2/digital-menu-board/'
  },
  ZOHO_BOT: false,
  MULTI_COMPOSITION: false,
  GOOGLE: {
    API_KEY: 'AIzaSyAABXnVYT7FIskoUKMqoxfXpRKWglOXg3g',
    CLIENT_ID: '525667527009-sg8acsdr4pekprle651vi41mtmb0blkf.apps.googleusercontent.com',
    DISCOVERY_DOCS: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
    SCOPE: 'https://www.googleapis.com/auth/calendar'
  },
  STATION: {
    HOST_NAME: 'stations'
  },
  DEVICE_PROFILE: false,
  LOAD_MOBILE: true,
  BLOCK_MOBILE_CONTENT: false,
  PRODUCT_CATALOG: {
    HOST_NAME: 'product-catalogue',
    IMG_LOGO: 'https://d2qf6k8jfqd09k.cloudfront.net/v3-apps/product-catalogue.svg',
    BASE_URL: 'https://widget.pickcel.com/v2/product-catalogue/'
  },
  I18n: true, 
  lang: 'english',
  SUPPORT_DOC: false,
  INITIAL_DATE: new Date(2021, 8, 15, 0, 0, 0, 0),
  CLIENT_NAME: 'Remote Screen Control',
  SHOW_PICKCEL_GO: false,
  SHOW_OTHER_MEDIA: false
}